import React from 'react';
import { Grade } from '../types';
interface SafetyBadgeProps {
  grade: Grade;
  size?: 'small' | 'large';
  className?: string;
}
export function SafetyBadge({
  grade,
  size = 'small',
  className = ''
}: SafetyBadgeProps) {
  const config = {
    A: {
      color: 'bg-green-100 text-green-700 ring-green-600/20',
      label: 'Excellent',
      iconColor: 'text-green-500'
    },
    B: {
      color: 'bg-blue-100 text-blue-700 ring-blue-600/20',
      label: 'Good',
      iconColor: 'text-blue-500'
    },
    C: {
      color: 'bg-amber-100 text-amber-700 ring-amber-600/20',
      label: 'Needs Improvement',
      iconColor: 'text-amber-500'
    },
    F: {
      color: 'bg-red-100 text-red-700 ring-red-600/20',
      label: 'Critical Issues',
      iconColor: 'text-red-500'
    }
  };
  const {
    color,
    label
  } = config[grade];
  if (size === 'large') {
    return <div className={`flex flex-col items-center justify-center p-6 rounded-2xl ring-1 ring-inset ${color} ${className}`} data-id="element-112">
        <span className="text-6xl font-black tracking-tighter mb-2" data-id="element-113">
          {grade}
        </span>
        <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-114">
          {label}
        </span>
      </div>;
  }
  return <span className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-bold ring-1 ring-inset ${color} ${className}`} data-id="element-115">
      <span className="text-sm" data-id="element-116">{grade}</span>
      <span className="hidden sm:inline font-medium opacity-90 border-l border-current pl-1.5" data-id="element-117">
        {label}
      </span>
    </span>;
}